import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "decorations"]
  static values = {
    spacing: { type: Number, default: 500 },
    imageUrl: String
  }

  initialize() {
    this.mediaquery = window.matchMedia("(max-width: 1024px)")
  }

  connect() {
    this.setupDecorations()
    // this.setupObservers()
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    if (this.contentObserver) {
      this.contentObserver.disconnect()
    }
  }

  setupDecorations() {
    // Check if the media query matches
    if (this.mediaquery.matches) {
      // If it matches, do not set up decorations
      this.decorationsTarget.innerHTML = ""
      return
    }
    const contentHeight = this.contentTarget.offsetHeight - (this.spacingValue)
    const numberOfDecorations = Math.ceil(contentHeight / this.spacingValue)

    // Clear existing decorations
    this.decorationsTarget.innerHTML = ""

    // Create new decorations
    for (let i = 0; i < numberOfDecorations; i++) {
      const spacing = i * this.spacingValue + this.spacingValue / 2
      const decoration = document.createElement("div")
      decoration.className = "decorative-element"
      decoration.style.top = `${spacing}px`
      decoration.style.backgroundImage = `url('${this.imageUrlValue}')`
      this.decorationsTarget.appendChild(decoration)
    }
  }

  // setupObservers() {
  //   // Watch for content size changes
  //   this.resizeObserver = new ResizeObserver(() => {
  //     this.setupDecorations()
  //   })
  //   this.resizeObserver.observe(this.contentTarget)

  //   // Watch for content changes
  //   this.contentObserver = new MutationObserver(() => {
  //     this.setupDecorations()
  //   })
  //   this.contentObserver.observe(this.contentTarget, {
  //     childList: true,
  //     subtree: true,
  //     characterData: true
  //   })
  // }
}
